import * as Yup from 'yup'
import { resetFormatoMonto } from './Formatos';

export const validationSchemas = (isGastoHonorario, limitePesadoBytes = 20 * 1000000) => {

  let validationObject = {};
  validationObject["tipoGasto"] = Yup.string().required('Campo obligatorio.');
  //validationObject["cobertura"] = Yup.string().required('Campo obligatorio.');
  validationObject["moneda"] = Yup.string().required('Campo obligatorio.');
  validationObject["fechaOcurrencia"] = Yup.date().required('Campo obligatorio.');
  validationObject["monto"] = Yup.string().test('montoMayot', 'Monto mayor a 0.', value => Number(resetFormatoMonto(value)) > 0);

  if (!isGastoHonorario) {
    validationObject.file = Yup
      .mixed()
      .required('Debe adjuntar documento digital de respaldo.')
      .test('fileSize', `Tamaño máximo del archivo ${limitePesadoBytes / 1000000}MB.`,
          (value) => {
              if (!value) return true;
              return value.size <= limitePesadoBytes;
          })
  }
  return Yup.object().shape(validationObject);
}

